import React, { useState, useEffect } from "react";
import Card from "../../../Components/share/cards/Card";
import { BtnPrimary } from "../../share/buttons/Btn";
import IconButton from "../../share/buttons/IconButton";
import { ReactComponent as Edit } from "../../../Assets/Image/svg/edit.svg";
import { AiOutlineAppstore, AiOutlineBorder } from "react-icons/ai";
import AdminPagination from "../../../Components/share/Pageination/AdminPagination";
import { Modal } from "../../share/modal/Modal";
import NewQuestion from "./NewQuestion";
import MainPagination from "../../share/Pageination/MainPagination";

function RefereeSurvey({ surveyType, list, getSurveysQuestions }) {
    const [newSurvey, setNewSurvey] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
    });
    useEffect(() => {
        getSurveysQuestions.reFetch();
    }, [pagination]);

    return (
        <div className=" w-full">
            <div className=" flex SupportTicket__header justify-between items-center leading-[3.2rem] mt-[4.5rem]">
                <h3 className=" text-[#212121E5] text-[1.8rem] font-normal ">
                    سوالات نظرسنجی داوری:
                </h3>
                <BtnPrimary
                    text="+ سوال جدید"
                    className=" px-12 py-8 "
                    onClick={() => setNewSurvey(true)}
                />
            </div>
            <Card className="  SupportTicketTable-header SupportTicketTable-card SupportTicketTable-card-towcol mt-[1.2rem]">
                <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]  text-right">
                    سوال
                </div>
                <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem] text-right">
                    نوع
                </div>
                <div></div>
            </Card>
            {list?.map((i, id) => (
                <Card
                    key={i?.id}
                    className="SupportTicketTable-card SupportTicketTable-card-towcol SupportTicketTable-body  my-4 starttable"
                >
                    <div className=" cursor-pointer text-right flex items-center justify-start starttable">
                        <AiOutlineAppstore className=" inline-block text-[#21212199] text-[2.4rem] w-[4rem] ml-[1.5rem]" />

                        {i?.name}
                    </div>
                    <div className=" text-right">{i?.date}</div>

                    <div>
                        <div className="flex items-end">
                            <IconButton data-tip="ویرایش" className="">
                                <Edit />
                            </IconButton>
                            <IconButton data-tip="انتخاب" className="">
                                <input
                                    type="radio"
                                    name={i?.name}
                                    value={i?.name}
                                    className="form-check-input PriceForm radio-lg mr-[1rem]"
                                    id={i?.name}
                                />
                            </IconButton>
                        </div>
                    </div>
                </Card>
            ))}
            <MainPagination
                pagination={pagination}
                setPagination={setPagination}
                data={list?.results}
                pageSize={list?.page_count}
                className="mt-[3rem]"
            />
            <Modal show={newSurvey}>
                <NewQuestion close={setNewSurvey} surveyType={surveyType} />
            </Modal>
        </div>
    );
}

export default RefereeSurvey;
